module.exports = __webpack_public_path__ + "static/index/img/baikal-201.13de11de.jpg";